
import Page from '@/Page.vue';
import { Component, Watch } from 'vue-property-decorator';
import { locationsStore } from '@/libs/locations/+state/store';
import { LocationModel } from '@/libs/Api';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import LocationShifts from '@/libs/shifts/components/LocationShifts.vue';
import ShiftDetailDialog from '@/libs/shifts/components/ShiftDetailDialog.vue';
import ShiftManagementCalendar from '@/libs/shifts/components/ShiftManagementCalendar.vue';
import ShiftManagementDetail from '@/libs/shifts/components/ShiftManagementDetail.vue';
import ShiftReportLocation from '@/libs/shifts/components/ShiftReportLocation.vue';

@Component({
    components: { ShiftReportLocation, ShiftManagementDetail, ShiftManagementCalendar, ShiftDetailDialog, LocationShifts },
})
export default class ShiftReport extends Page {
    locationId: string | null = null;
    showLocationSheet = false;

    @Watch('locationId')
    locationIdChanged(v: string | null) {
        this.setQuery('location', v, true);
    }

    created() {
        if (this.getQuery('location', true)) {
            this.locationId = this.getQuery('location', true);
        }
    }

    get locations(): LocationModel[] {
        const locations = locationsStore.useGetter(CrudGetter.Data) as LocationModel[];
        return locations.filter((x) => x.canPlanShifts);
    }

    get selectedLocationName(): string {
        const location = this.locations.find((x) => x.id === this.locationId);
        return location?.name || this.$t('shift.selectLocation').toString();
    }

    selectLocation(location: LocationModel) {
        this.locationId = location.id!;
        this.showLocationSheet = false;
    }
}
